import { Row, Col, Card, Button, Skeleton, Image, Divider } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import Main from "../../components/layout/Main";
import apiPath from "../../constants/apiPath";
import { Badge } from 'antd';
import notfound from "../../assets/images/not_found.png"
import moment from 'moment';

function View() {

  const params                =   useParams();
  const { request }           =   useRequest();
  const [list, setList]       =   useState({});
  const [loading, setLoading] =   useState(false);

  const fetchData = (id) => {
    request({
      url: apiPath.viewWasher + "/" + id,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchData(params.id)
  }, [])

  return (
    <Main>
      <Card title="Washer Details">
        <Row gutter={16}>
          <Col span={12} xs={24} md={24}>
            
            {loading ? <Skeleton active /> : 
              <div className="view-main-list">


                <div className="view-inner-cls">
                  <h5>Image:</h5>
                  <h6><Image width={100} height={100} className="float-right" src={list.image ? list.image : notfound} /></h6> 
                </div>

                <div className="view-inner-cls">
                  <h5>Name:</h5>
                  <h6>{list.name}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Phone Number:</h5>
                  <h6>{list ? '+' + list.country_code + '-' : '+968'}{list ? list.mobile_number : '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Notification Status:</h5>
                  <h6>{list && list.notification ? 'Yes' : 'No'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Is WhatsApp Number:</h5>
                  <h6>{list && list.is_your_whatsapp_no ? 'Yes' : 'No'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>DOB:</h5>
                  <h6>{list && list.dob ? moment(list.dob).format("DD, MMMM YYYY") : '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Gender:</h5>
                  <h6>{list && list.gender ? list.gender : '-'}</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>Status:</h5>
                  <h6>{list.is_active ? <Badge status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                </div>

                {list && list.is_delete ? 
                  <div className="view-inner-cls">
                    <h5>Account Deleted:</h5>
                    <h6><Badge status="error" text="Deleted" /></h6>
                  </div>
                : null}

                <div className="view-inner-cls">
                  <h5>Registered On:</h5>
                  <h6>{list.created_at ? moment(list.created_at).format('DD-MM-YYYY') : '-'}</h6>
                </div>

                <div className="view-inner-cls float-right">
                  <Link className="ant-btn ant-btn-default" to="/washer/">Back</Link>
                </div>

              </div>
            }

          </Col>
        </Row>
      </Card>
    </Main >
  );
}

export default View;
